import { useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ChevronDown, ChevronRight, Settings } from "lucide-react";
import { collectUncodedBidItems } from "../../../hooks/useBillingInitialization";

export const UncodedItemsWarning = ({ job, jobId }) => {
  const [open, setOpen] = useState(false);
  const items = collectUncodedBidItems(job);
  if (!items.length) return null;
  const shown = open ? items : items.slice(0, 5);

  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50 p-4" role="status" data-testid="uncoded-items-warning">
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-amber-900" data-testid="uncoded-items-count">
            {items.length} bid item{items.length === 1 ? "" : "s"} {items.length === 1 ? "has" : "have"} no billing category
          </p>
          <p className="text-sm text-amber-800">
            They will land on the Schedule of Values under their material category / "Miscellaneous". Code them in Settings → Bid Items (or set an override on the bid sheet line), then use "Regenerate from Bids".
          </p>
          <ul className="mt-2 text-sm text-amber-900 space-y-0.5" data-testid="uncoded-items-list">
            {shown.map((it) => (
              <li key={it.key} className="flex flex-wrap gap-x-2">
                <span className="font-medium">{it.name}</span>
                <span className="text-amber-700">· {it.kind} · {it.sheet} → will bill as "{it.fallback}"</span>
              </li>
            ))}
          </ul>
          <div className="mt-2 flex flex-wrap items-center gap-3 text-sm">
            {items.length > 5 && (
              <button type="button" onClick={() => setOpen((o) => !o)} className="inline-flex items-center gap-1 text-amber-900 underline underline-offset-2" data-testid="uncoded-items-toggle">
                {open ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
                {open ? "Show fewer" : `Show all ${items.length}`}
              </button>
            )}
            <Link to="/settings?tab=bid-items" className="inline-flex items-center gap-1 text-amber-900 underline underline-offset-2" data-testid="uncoded-items-settings-link">
              <Settings className="w-4 h-4" /> Open Bid Items settings
            </Link>
            <Link to={`/jobs/${jobId}?tab=estimating`} className="text-amber-900 underline underline-offset-2" data-testid="uncoded-items-bidsheet-link">
              Open bid sheets
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UncodedItemsWarning;
